const NULL_ACTION = { type: null };

export default NULL_ACTION;
